module.exports = __webpack_public_path__ + "static/media/ic_inbound_co_browse_activate.6b94649a.svg";